import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { activities, awards, labels, nav } from '../data/content';
import Section from './Section';
import { LABEL } from './styles';

export default function Awards() {
  const { t } = useLanguage();

  return (
    <Section id="awards" title={t(nav.awards)}>
      <div className="grid gap-x-12 gap-y-10 md:grid-cols-2">
        <div>
          <h3 className={LABEL}>{t(labels.awardsTitle)}</h3>
          <ol className="divide-y divide-stone-200">
            {awards.map((a) => (
              <li key={a.year + a.name.en} className="py-5">
                <p className="text-xs tabular-nums text-stone-500">{a.year}</p>
                <p className="mt-1 text-pretty font-semibold">{t(a.name)}</p>
                <p className="text-sm text-stone-600">{t(a.note)}</p>
              </li>
            ))}
          </ol>
        </div>

        <div>
          <h3 className={LABEL}>{t(labels.activitiesTitle)}</h3>
          <ol className="divide-y divide-stone-200">
            {activities.map((a) => (
              <li key={a.period + a.name.en} className="py-5">
                <p className="text-xs tabular-nums text-stone-500">{a.period}</p>
                <p className="mt-1 text-pretty font-semibold">{t(a.name)}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </Section>
  );
}
